/* ==============================
   CWC Reason Cards - Swiper Carousel
   Desktop: 3 visible | Mobile: 1.15 (peek)
   ============================== */

(function() {
  'use strict';

  function initReasonCarousels() {
    var carousels = document.querySelectorAll('[data-reason-cards-carousel]');

    if (!carousels.length) return;

    carousels.forEach(function(carousel) {
      var prevBtn = carousel.querySelector('.cwc_reason-cards__carousel-prev');
      var nextBtn = carousel.querySelector('.cwc_reason-cards__carousel-next');
      var progressBar = carousel.querySelector('.cwc_reason-cards__carousel-progress-bar');

      function updateProgress(s) {
        if (!progressBar) return;
        var slidesPerView = s.params.slidesPerView;
        if (typeof slidesPerView !== 'number') slidesPerView = 1;
        var total = s.slides.length - Math.floor(slidesPerView);
        var progress = total > 0 ? (s.activeIndex / total) * 100 : 100;
        progressBar.style.width = Math.min(progress, 100) + '%';
      }

      new Swiper(carousel, {
        slidesPerView: 3,
        spaceBetween: 16,
        loop: false,
        speed: 400,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        breakpoints: {
          0: {
            slidesPerView: 1.15,
            spaceBetween: 12
          },
          480: {
            slidesPerView: 1.4,
            spaceBetween: 14
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 16
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 16
          }
        },
        on: {
          init: updateProgress,
          slideChange: updateProgress,
          resize: updateProgress
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReasonCarousels);
  } else {
    initReasonCarousels();
  }

  document.addEventListener('shopify:section:load', initReasonCarousels);
})();
